import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAccess } from '../../../hooks/useAccess';
import { Paths } from '../../../shared/paths';
import { BugReportsInnerTabs } from './BugReportsInnerTabs';

export default function BugReports() {
  const { access } = useAccess();
  const canView =
    (access?.bugReports?.canView ?? false) ||
    (access?.bugReports?.canResponse ?? false);

  if (!canView) {
    return <Navigate to={Paths.root} replace />;
  }

  return <BugReportsInnerTabs />;
}
